<template>
  <div>
    <b-card title="" class="text-center mx-auto">
      <h1>
        <digital-clock :blink="false" :displaySeconds="true" :twelveHour="false"/>
        WIB
      </h1>
      <p class="mb-3">
        {{ moment(new Date()).format("dddd, Do MMMM YYYY") }}
      </p>
      <div v-if="!can_presence">
        <b-alert
            :variant="slug"
            show
        >
          <div class="alert-body">
            <span><strong> {{ message }}</strong></span>
          </div>
        </b-alert>
      </div>
      <div v-else>
        <div class="col-md-12" v-if="!tooFar">
          <div v-if="!beginCapture">
            <b-alert
                variant="warning"
                show
            >
              <div class="alert-body">
                <span><strong> Silahkan Izinkan Akses Kamera Anda dan tunggu beberapa saat</strong></span>
              </div>
            </b-alert>
          </div>
          <div v-else>
            <code v-if="!device">Tidak Ada Kamera</code>
            <figure class="figure" v-if="img">
              <img :src="img" class="img-responsive"/>
            </figure>
            <div v-show="!img">
              <web-cam
                  ref="webcam"
                  :device-id="deviceId"
                  width="100%"
                  @started="onStarted"
                  @stopped="onStopped"
                  @error="onError"
                  @cameras="onCameras"
                  @camera-change="onCameraChange"
              />
              <div class="row">
                <div class="col-md-12">
                  <h3>Pilih Kamera</h3>
                  <select v-model="camera" class="mb-2">
                    <option>-- Pilih kamera --</option>
                    <option
                        v-for="device in devices"
                        :key="device.deviceId"
                        :value="device.deviceId"
                    >{{ device.label }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12 text-center mx-auto">
                  <b-button
                      v-ripple.400="'rgba(0, 207, 232, 0.15)'"
                      variant="outline-success bg-white text-primary"
                      class="btn-icon rounded-circle btn-primary"
                      @click="onCapture"
                  >
                    <feather-icon icon="CameraIcon"/>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="demo-spacing-0" v-else>
          <b-alert
              variant="danger"
              show
          >
            <div class="alert-body">
              <span><strong>Anda Terlalu Jauh dari Lokasi!</strong></span>
              <div>
                <b-button
                    :disabled="loading"
                    @click="geolocationGetCurrentPosition"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="danger"
                >
                  <div v-if="loading">
                    <b-spinner small/>
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div v-else>
                    Coba Lagi
                  </div>
                </b-button>
              </div>
            </div>
          </b-alert>
          <b-card title="Lokasi Anda" class="text-center mx-auto">
            <map-component v-if="location && location.longitude && location.latitude"  ref="mapsComponent" :longitude="location.longitude" :latitude="location.latitude"></map-component>
          </b-card>
        </div>
      </div>
    </b-card>
    <b-modal
        :no-close-on-backdrop="true"
        centered
        size="lg"
        id="modal-task"
        ref="modalTask"
        title="Task"
        :ok-disabled="loading"
        ok-title="Simpan"
        cancel-title="Batal"
        cancel-variant="outline-primary"
        @hidden="resetModal"
        @ok="handleOk"
    >
      <b-overlay :show="loading" rounded="sm">
      <form
          ref="form"
          @submit.stop.prevent="handleSubmit"
      >
        <b-form-group
            :state="taskState.detail"
            label="Apa yang anda kerjakan hari ini?"
            label-for="name-input"
            invalid-feedback="Detail Harus di isi"
        >
          <b-form-textarea
              id="detail-input"
              v-model="task.detail"
              :state="taskState.detail"
              required
          />
        </b-form-group>

        <b-form-group
            label="Bukti Foto"
            label-for="foto"
            :state="taskState.foto"
        >
          <b-form-file
              id="foto"
              accept="image/*"
              :state="taskState.foto"
              v-model="task.foto"
          />
        </b-form-group>

        <img v-if="task.fotoBase64" :src="task.fotoBase64" alt="Foto" class="img-thumbnail">

      </form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {BCard, BCardText, BLink, BAlert, BButton, BSpinner, BModal, BFormTextarea, BFormGroup, BFormFile, BOverlay} from 'bootstrap-vue'
import {WebCam} from "vue-web-cam";
import DigitalClock from "vue-digital-clock";
import axios from "axios";
import Ripple from 'vue-ripple-directive'
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import mapComponent from './Components/Map'

export default {
  components: {
    BModal,
    BCard,
    BCardText,
    BLink,
    BAlert,
    WebCam,
    BButton,
    BSpinner,
    DigitalClock,
    mapComponent,
    BFormTextarea,
    BFormGroup,
    BFormFile,
    BOverlay
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      beginCapture: true,
      loading: false,
      tooFar: null,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      location: null,
      gettingLocation: false,
      errorStr: null,
      can_presence: false,
      message: null,
      slug : 'primary',
      isCheckout : false,
      task : {
        detail : null,
        foto : null,
        fotoBase64 : null,
      },
      taskState : {
        detail : null,
        foto : null,
      }
    };
  },
  computed: {
    device: function () {
      return this.devices.find(n => n.deviceId === this.deviceId);
    },
    user() {
      return this.$store.getters.user
    },
  },
  watch: {
    'task.foto': {
      deep: true,
      handler(val, oldVal) {
        if (val) {
          this.createBase64Image(val)
        } else {
          this.task.fotoBase64 = null
        }
      }
    },
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
    location: {
      deep: true,
      async handler(val, oldVal) {
        let that = this
        if (val) {
          let self = this
          self.loading = true
          await axios.get('api/presensi/check', {
            params: {
              'longitude': val.longitude,
              'latitude': val.latitude,
            }
          }).then((response) => {
            self.loading = false
            self.tooFar = false
          }).catch(function (error) {
            self.loading = false
            self.tooFar = true
            that.$emit('refreshMap');
          })
        }
      }
    },
  },
  methods: {
    async onCapture() {
      this.img = this.$refs.webcam.capture();
      await this.checkAbsence()
    },
    onStarted(stream) {
      // console.log("On Started Event", stream);
    },
    onStopped(stream) {
      // console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      // console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      // console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      // console.log("On Camera Change Event", deviceId);
    },
    geolocationGetCurrentPosition() {
      if (!("geolocation" in navigator)) {
        this.errorStr = 'Geolocation is not available.';
        return;
      }

      this.gettingLocation = true;
      // get position
      navigator.geolocation.getCurrentPosition(pos => {
        this.gettingLocation = false;
        this.location = pos.coords;
      }, err => {
        this.gettingLocation = false;
        this.errorStr = err.message;
      })
    },
    async checkAbsence(){
      // if(this.isCheckout){
      //     this.showModal();
      // }else{
          await this.sendAbsence();
      // }
    },
    async sendAbsence() {
      this.loading = true
      const form = {
        'longitude': this.location.longitude,
        'latitude': this.location.latitude,
        'image': this.img,
        // 'task' : this.task
      }
      await axios.post("api/presensi", form).then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Absen berhasil!',
            icon: 'CheckCircleIcon',
            variant: 'success',
          },
        })
        if(this.isCheckout){
          this.$router.push('/pegawai/task')
        }else{
          this.$router.push('/')
        }
      }).catch(function (error) {
        if (error.response) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error.response.data.message',
              icon: 'XCircleIcon',
              variant: 'success',
            },
          })
        }
      });
    },
    async checkAttendance() {
      await axios.get("api/presensi/state-check").then((res) => {
        let data = res.data.data
        var format = 'hh:mm:ss'

        var time = this.$moment(),
            beforeTimeCheckin = this.$moment(data.checkin_times_start, format),
            afterTimeCheckin = this.$moment(data.checkin_times_end, format),
            beforeTimeCheckout = this.$moment(data.checkout_times_start, format),
            afterTimeCheckout = this.$moment(data.checkout_times_end, format);

        this.isCheckout = data.checkout

        this.can_presence = data.presensi
        this.slug = data.slug
        this.message = data.message
      }).catch(function (error) {
        if (error.response) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error.response.data.message',
              icon: 'XCircleIcon',
              variant: 'success',
            },
          })
        }
      });
    },
    showModal() {
      this.$refs.modalTask.show()
    },
    hideModal() {
      this.$refs.modalTask.hide()
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.taskState.detail = valid
      this.taskState.foto = valid
      return valid
    },
    resetModal() {
      this.onStart();
      this.img = null
      this.task.detail = null
      this.taskState.detail = null
      this.task.foto = null
      this.task.fotoBase64 = null
      this.taskState.foto = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      this.sendAbsence();
      // Push the name to submitted names
      // this.submittedNames.push(this.name)
      // Hide the modal manually
      // this.$nextTick(() => {
      //   this.$refs.modalTask.toggle('#toggle-btn')
      // })
    },
    createBase64Image: function (fileObject) {
      const self = this;
      const reader = new FileReader()
      reader.onload = function (e) {
        self.task.fotoBase64 = e.target.result
      }
      reader.readAsDataURL(fileObject);
    },
  },
  created() {
    this.geolocationGetCurrentPosition()
    if (this.user) {
      if (this.user.type === "Pegawai") {
        this.checkAttendance()
      }
    }
  }
}
</script>

<style>

</style>
